import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BackButton } from 'src/app/shared/interfaces/back-button.interface';
import { EBiometricsType } from 'src/app/shared/interfaces/biometrics.interface';
import { BiometricsDataService } from './biometrics-data.service';

@Injectable({
  providedIn: 'root'
})
export class BackButtonService {
  backButton$ = new BehaviorSubject<BackButton>({
    visible: false,
    to: ''
  });
  constructor(private biometricsDataService: BiometricsDataService) {}

  checkScreen(type: EBiometricsType, screenKey: string) {
    if (
      this.biometricsDataService.routingBiometrics[type][screenKey].previous
    ) {
      this.backButton$.next({
        visible: true,
        to: this.biometricsDataService.routingBiometrics[type][screenKey]
          .previous
      });
    } else {
      this.backButton$.next({
        visible: false,
        to: ''
      });
    }
  }

  hideBackButton(): void {
    this.backButton$.next({
      visible: false,
      to: ''
    });
  }
}
